<script>
export default {
    props: {
        filter: Object,
        categories: Object,
    },
    data() {
        return {
            categoryId: null,
        }
    },
    mounted() {
        this.categoryId = this.$root.filter.categoryId;

        $('#jstree').jstree({
            'plugins': ["wholerow"],
            'core': {
                'themes': {
                    'name': 'proton',
                    'responsive': true
                }
            }
        });
        $('#jstree').jstree('select_node', this.categoryId);
        $('#jstree').on("changed.jstree", (e, data) => {
            if (data.node) {
                this.categoryId = data.node.id;
                this.$nextTick(() => this.$root.startSearch());
            }
        });
    },
    watch: {
        categoryId(value) {
            this.$set(this.$root.filter, 'categoryId', value);
        },
        filter(value) {
            if (value.reset) {
                this.categoryId = false;
            }
        }
    },
}
</script>

<template>
    <div>
        <h5 class="m-t-md m-b-xs">Kategorie</h5>
        <div class="m-b">
            <div id="jstree">
                <ul>
                    <tree-node
                            class="jstree-open"
                            :node="categories"
                            label="Alle"
                            :children-collapsed="true"
                    ></tree-node>
                </ul>
            </div>
        </div>
    </div>
</template>
